import React from 'react'
import { twMerge } from 'tailwind-merge'

export const ProgressInfoRow = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={twMerge('flex items-center justify-between text-base font-medium', className)}
    {...props}
  />
)

ProgressInfoRow.displayName = 'ProgressInfoRow'
